const cartContainsSubscriptionProducts = () => {
  const cart = window.wlcrWyldCart;

  const items = cart.items;
  let hasSubscriptions = false;
  for (var i = 0; i < items.length; i++) {
    if (items[i].properties !== null) {
      if (items[i].properties['shipping_interval_frequency']) {
        hasSubscriptions = true;
        break;
      }
    }
  }
  return hasSubscriptions;
};

export default cartContainsSubscriptionProducts;
